<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}->{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="评价记录" name="first">
                <child1></child1>
            </el-tab-pane>

            <el-tab-pane label="我的评价" name="four">
                <child4></child4>
            </el-tab-pane>

            <el-tab-pane label="学生评价统计" name="second">
                <child2></child2>
            </el-tab-pane>

            <el-tab-pane label="班级评价统计" name="three">
                <child3></child3>
            </el-tab-pane>

            <el-tab-pane label="教职评价统计" name="five">
                <child5></child5>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
import evaluate from './Evaluate'
import myEvaluate from './MyEvaluate'
import studentEvaluateCount from './StudentEvaluateCount'
import classEvaluateCount from './ClassEvaluateCount'
import teacherEvaluateCount from './TeacherEvaluateCount'

export default {
    name: "EvaluateMain",
    components: {
        child1: evaluate,
        child2: studentEvaluateCount,
        child3: classEvaluateCount,
        child4: myEvaluate,
        child5: teacherEvaluateCount,
    },
    data() {
        return {
            menuName: "",
            //默认第一个选项卡
            activeName: "first",
            title: "评价记录"
        }
    },
    created: function () {
        this.menuName = sessionStorage.getItem("selectMenuItem_key");
    },
    methods: {
        handleClick(tab) {
            if (tab.name == "first") {
                this.activeName = 'first';
                this.title = "评价记录";
            }else if(tab.name == "four") {
                this.activeName = 'four';
                this.title="我的评价";
            }else if (tab.name == "second") {
                this.activeName = 'second';
                this.title = "学生评价统计";
            } else if (tab.name == "three") {
                this.activeName = 'three';
                this.title = "班级评价统计";
            } else if (tab.name == "five") {
                this.activeName = 'five';
                this.title = "教职评价统计";
            }
        }
    }
}

</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/EvaluateMain.vue